import { render, staticRenderFns } from "./templateService.vue?vue&type=template&id=5dc988fc&scoped=true&"
import script from "./templateService.vue?vue&type=script&lang=js&"
export * from "./templateService.vue?vue&type=script&lang=js&"
import style0 from "./templateService.vue?vue&type=style&index=0&id=5dc988fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc988fc",
  null
  
)

export default component.exports